export default "__VITE_ASSET__C6wmFW_y__"